import axios from 'axios';

export const FETCH_DRAWS_REQUEST = 'FETCH_DRAWS_REQUEST';
export const FETCH_DRAWS_SUCCESS = 'FETCH_DRAWS_SUCCESS';
export const GET_PENDING_DRAWS = 'GET_PENDING_DRAWS';
export const GET_CURRENT_DRAWS = 'GET_CURRENT_DRAWS'
export const DRAW_ERROR = 'DRAW_ERROR'
export const FETCH_DRAWS_FAILURE = 'FETCH_DRAWS_FAILURE';
export const FETCH_DRAW_HISTORY_SUCCESS = 'FETCH_DRAW_HISTORY_SUCCESS';
export const UPDATE_SCRIPT_STATUS = 'UPDATE_SCRIPT_STATUS';


const base_url  = process.env.REACT_APP_API_URL_ADMIN;
 

export const getDraws = () => async (dispatch) => {
    dispatch({ type: FETCH_DRAWS_REQUEST });
    try {
        const response = await axios.post(`${base_url}`, {
            apiName: 'draw',
            command: 'getDraws'
        });
        dispatch({
            type: FETCH_DRAWS_SUCCESS,
            payload: response.data.data
        });
    } catch (error) {
        dispatch({
            type: FETCH_DRAWS_FAILURE,
            payload: error.response?.data?.message || 'Failed to fetch draws'
        });
        throw error;
    }
};

export const getPendingDraws = () => async (dispatch) => {
    try {
        const response = await axios.post(`${base_url}`, {
            apiName: 'draw',
            command: 'pendingDraws'
        });
        dispatch({ type: GET_PENDING_DRAWS, payload: response.data.data });
    } catch (error) {
        dispatch({ type: DRAW_ERROR, payload: error.response?.data?.message || 'Failed to fetch pending draws' });
    }
};

export const getCurrentDraws = () => async (dispatch) => {
    try {
        const response = await axios.post(`${base_url}`, {
            apiName: 'draw',
            command: 'currentDraw'
        });
        dispatch({ type: GET_CURRENT_DRAWS, payload: response.data.data });
    } catch (error) {
        dispatch({ type: DRAW_ERROR, payload: error.response?.data?.message || 'Failed to fetch current draws' });
    }
};

export const startScript = () => async (dispatch) => {
    try {
        const response = await axios.post(`${base_url}`, {
            apiName: 'draw',
            command: 'startScript'
        });
        dispatch({
            type: UPDATE_SCRIPT_STATUS,
            payload: response.data.data
        });
        return response.data.data;
    } catch (error) {
        throw error.response?.data?.message || 'Failed to start script';
    }
};

export const stopScript = () => async (dispatch) => {
    try {
        const response = await axios.post(`${base_url}`, {
            apiName: 'draw',
            command: 'stopScript'
        });
        dispatch({
            type: UPDATE_SCRIPT_STATUS,
            payload: response.data.data
        });
        return response.data.data;
    } catch (error) {
        throw error.response?.data?.message || 'Failed to stop script';
    }
};

export const getScriptStatus = () => async (dispatch) => {
    try {
        const response = await axios.post(`${base_url}`, {
            apiName: 'draw',
            command: 'getScriptStatus'
        });
        dispatch({
            type: UPDATE_SCRIPT_STATUS,
            payload: response.data.data
        });
        return response.data.data;
    } catch (error) {
        throw error.response?.data?.message || 'Failed to get script status';
    }
};

export const shiftToHistory = () => async (dispatch) => {
    try {
        await axios.post(`${base_url}`, {
            apiName: 'draw',
            command: 'shiftToHistory'
        });
        // Refresh draws after shifting
        dispatch(getDraws());
    } catch (error) {
        throw error.response?.data?.message || 'Failed to shift draws to history';
    }
};

export const getDrawHistory = (params) => async (dispatch) => {
    try {
        const response = await axios.post(`${base_url}`, {
            apiName: 'draw',
            command: 'getDrawHistory',
            ...params
        });
        dispatch({
            type: FETCH_DRAW_HISTORY_SUCCESS,
            payload: response.data.data
        });
    } catch (error) {
        throw error.response?.data?.message || 'Failed to fetch draw history';
    }
};